// Modified https://vuejs.org/v2/examples/modal.html

<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <span><slot name="header">[header]</slot></span>
          </div>
          <div class="modal-body">
            <span class="modal-body-inner"><slot name="body">[body]</slot></span>
            <div
              class="modal-primary-button button-container"
              :class="{ 'is-destructive-alert': isDestructiveAlert }"
            >
              <div @click="handlePrimary">
                <span><slot name="primary-button-text">[action2]</slot></span>
              </div>
            </div>
            <div class="modal-secondary-button button-container" v-if="!hideSecondaryButton">
              <div @click="handleSecondary">
                <span><slot name="secondary-button-text">[action1]</slot></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DebouncedHandler from '@/services/DebouncedHandler';

export default {
  props: [
    'isDestructiveAlert', // :Boolean
    'hideSecondaryButton', // :Boolean
  ],
  methods: {
    handlePrimary: DebouncedHandler(function() {
      this.$emit('primary');
    }),
    handleSecondary: DebouncedHandler(function() {
      this.$emit('secondary');
    }),
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.modal-header {
  font-size: 20px;
  font-weight: bold;
  color: #2c3137;
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 24px 10px 5px;
  text-align: center;
  flex-basis: auto;
}

.modal-body {
  background-color: white;
  color: #656d78;
  text-align: center;
  padding-bottom: 24px;
  font-size: 16px;
  font-weight: 500;
  flex-basis: auto;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.modal-body-inner {
  display: inline-block;
  max-width: 90%;
  position: relative;
  padding-top: 3px;
  padding-bottom: 24px;
}

.button-container {
  padding: 10px 0;
  text-align: center;
  font-size: 18px;
  height: 25px;
  border-radius: 64px;
  margin: 0px 32px auto;
  transition: filter 0.25s;
}

.modal-primary-button {
  cursor: pointer;
  background-color: #0a92ff;
  color: white;
  font-weight: 700;
  box-shadow: 0px 1px 4px #00000029;
}

.modal-primary-button.is-destructive-alert {
  background-color: #f23c57;
}

.modal-secondary-button {
  cursor: pointer;
  background-color: #f7f8f9;
  color: #656d78;
  font-weight: 500;
  margin-top: 16px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  /* perspective sets the z distance to 10px, so when we translateZ by 1px,
  we get a +10% relative zoom i.e. 1.1x in the scale.
  See https://developer.mozilla.org/en-US/docs/Web/CSS/perspective and
  https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/translateZ
  using "transform: scale(1.1)" instead causes a flickerin line issue.
  See https://jira.sc-corp.net/browse/BM-5945 */
  -webkit-transform: perspective(10px) translateZ(1px);
  transform: perspective(10px) translateZ(1px);
}

.button-container:hover {
  filter: brightness(0.85) contrast(1.2);
}

.button-container:active {
  filter: brightness(0.75) contrast(1.5);
}

@media (prefers-color-scheme: dark) {
  .modal-header {
    color: #ffffff;
    background-color: #1b1b1b;
  }

  .modal-body {
    background-color: #1b1b1b;
    color: #797a80;
  }

  .modal-primary-button {
    background-color: #0a92ff;
    color: white;
  }

  .modal-secondary-button {
    background-color: #2b2b2b;
    color: #797a80;
  }
}
</style>
